import { NgModule } from '@angular/core';
import { VafUserDetailComponent } from './vaf-user-detail.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ViewAndFineRegistrationFormComponentModule } from '../../components/view-and-fine-registration-form/view-and-fine-registration-form.component.module';

@NgModule({
    declarations: [
        VafUserDetailComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatTooltipModule,
        MatProgressBarModule,
        ViewAndFineRegistrationFormComponentModule
    ]
})
export class VafUserDetailComponentModule { }
